export class ChatMessage {
    jobid: string;
    employerid: string;
    candidateid: string;
    from: string;
    message: string;
    time: Date;
    filePath: string;

    static parse(json): ChatMessage {
        let t = new Date(1970, 0, 1);
        let msg = new ChatMessage();
        msg = Object.assign(msg, json);
        t.setSeconds(json.time.seconds);
        msg.time = t;
        return msg;
    }
}
